Directives.NetworkListItemDirective = function NetworkListItemDirective() {

    // @ngInject
    function NetworkListItemDirectiveControllerFunc($scope, $injector, AppStates, CompanyService, $filter, NetworkManager, $state, ContactsManager, $translate, PopupMessageService, AnalyticsService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkListItemDirectiveController';
        this.AppStates = AppStates;
        this.$state = $state;
        this.PopupMessageService = PopupMessageService;
        this.$translate = $translate;
        this.AnalyticsService = AnalyticsService;
        this.CompanyService = CompanyService;
        this.NetworkManager = NetworkManager;
        this.vendorTypes = this.CompanyService.getCompanyTypesEnum();
        this.vendorTypeTranslationMap = this.CompanyService.getCompanyTypesTranslationMap();
        this.vendorTypeIconMap = this.CompanyService.getCompanyTypesIconMap();
        this.showListItem = true;
        this.ContactsManager = ContactsManager;

        this.loadBadges();
        this.loadConnectionInfo();

        if (this.isSuggestion /*&& !this.showRespondRequest*/) {
            //tell server user has been suggested
            this.NetworkManager.connectionSuggestionViewBulk(this.user._id);
        }

        this.register(this.user, 'success', function(successType, respStatus, respIsComplete) {
            this.loadBadges();
            this.loadConnectionInfo();
        }.bind(this));

        this.isDisableDeleteUser = false;

        this.sharedProjectsDropdownOpen = false;
        this.sharedProjectsLoadingError = false;
    }

    var NetworkListItemDirectiveController = Class(Controllers.BaseController, {

        constructor: NetworkListItemDirectiveControllerFunc,

        loadConnectionInfo: function loadConnectionInfo(){
            if (this.user.network.connection_data && this.user.network.connection_data.connection_status){
                this.connectionStatus = this.user.network.connection_data.connection_status;

                if (this.connectionStatus === 'needs_response' || this.connectionStatus === 'ignored') {
                    this.showRespondRequest = true;
                }
            }
        },

        updateConnection: function updateConnection(event, action) {
            event.stopPropagation();
            event.preventDefault();

            this.NetworkManager.updateConnection(this.user, action).then(function success() {
                if (action === 'ignore') {
                    this.showListItem = false;
                } else {
                    this.showRespondRequest = false;
                }

                if(this.onConnectionUpdate) {
                    this.onConnectionUpdate({action: action});
                }
            }.bind(this));
        },

        connect: function connect(event, user) {
            event.stopPropagation();
            event.preventDefault();
            this.NetworkManager.createConnectionRequest(this.user._id);
            if (this.isSuggestion) {
                this.NetworkManager.connectionSuggestionConvert(this.user._id);
            }
            this.connectionStatus = 'requested';

            if(this.onConnectionUpdate) {
                this.onConnectionUpdate({action: 'requested'});
            }
        },

        hasBadges: function hasBadges() {
            return this.hasBadgePro || this.hasBadgeRts;
        },

        loadBadges: function loadBadges() {
            this.hasBadgePro = false;
            this.hasBadgeRts = this.user.network.affiliation_rts;
        },

        showPreferred: function showPreferred() {
            return (this.isSuggestion && (this.connectionStatus && (this.connectionStatus === 'requested'))) ||
                   (!this.isSuggestion && (this.connectionStatus !== 'needs_response') &&
                   !this.isProfileConnection);
        },

        showConnectedStatus: function showConnectedStatus() {
            return this.currentState !== this.AppStates.root_core_navigation_my_connections;
        },
        
        showSharedProjects: function showSharedProjects() {
            return this.currentState === this.AppStates.root_core_navigation_my_connections;
        },

        handleClickSharedProjectsToggle: function handleClickSharedProjectsToggle(event) {
            event.preventDefault();
            event.stopPropagation();

            this.isLoadingSharedProjects = true;
            this.sharedProjectsLoadingError = false;
            this.sharedProjectsDropdownOpen = !this.sharedProjectsDropdownOpen;
            if (this.sharedProjectsDropdownOpen) {
                this.ContactsManager.getWorkspaceConnectionsForContact(this.contact)
                    .then(function() {
                        // this.contact is bound to parent scope
                    }.bind(this))
                    .catch(function() {
                        this.sharedProjectsLoadingError = true;
                    }.bind(this))
                    .finally(function() {
                        this.isLoadingSharedProjects = false;
                    }.bind(this));
            }
        },

        handleClickOutsideSharedProjects: function handleClickOutsideSharedProjects() {
            this.sharedProjectsDropdownOpen = false;
        },
        
        handleClickSharedProject: function handleClickSharedProject(workspace_id, event_id) {
            event.preventDefault();
            event.stopPropagation();

            this.sharedProjectsDropdownOpen = false;

            this.goToState(this.AppStates.root_core_navigation_event_workspace_feed, {
                workspace_id: workspace_id,
                event_id: event_id
            });
        },
        
        handleClickHideSuggestion: function handleClickHideSuggestion(event) {
            event.preventDefault();
            event.stopPropagation();
            this.showListItem = false;
            this.NetworkManager.connectionSuggestionHide(this.user._id);
        },

       togglePreferred: function togglePreferred(event) {
           event.stopPropagation();
           event.preventDefault();

           if(!this.contact) {
               this.ContactsManager.createPreferredContact(this.user, 'community', true)
                    .then(function success(response) {
                        this.contact = response.data;
                    }.bind(this));
           } else {
               this.ContactsManager.updatePreferredVendorContact(this.contact, !this.contact.is_preferred)
                    .then(function success(resp){
                        this.contact.is_preferred = resp.data.is_preferred;
                    }.bind(this));
            }
        },

        deleteConnection: function deleteConnection(event) {

            event.stopPropagation();
            event.preventDefault();
                var onCancel = function() {
                };

                // show confirmation popup
                var confirmMsg = this.$translate.instant('NETWORK.DIRECTORY._CONFIRM_CONNECTION_DELETE_');
                this.PopupMessageService.showConfirm(
                    this.PopupMessageService.severityTypes.warning,
                    confirmMsg,
                    function () {
                        this.deleteConnectionInner(event);
                    }.bind(this),
                    onCancel.bind(this));

        },

        deleteConnectionInner: function deleteConnectionInner(event) {
            this.isDisableDeleteUser = true;
            var parentElement = $(event.target).parents('.person');
            parentElement.addClass('person--deleted');

            this.NetworkManager.updateConnection(this.user, 'delete')
                .then(function success() {

                if(this.onConnectionUpdate) {
                    this.onConnectionUpdate({action: 'delete'});
                }

                this.AnalyticsService.track(this, 'delete connection');
            }.bind(this))
           .catch(function onFail() {
               this.isDisableDeleteUser = false;
               parentElement.removeClass('person--deleted');
           });
        },


        isPreferred: function isPreferred() {
            return this.contact && this.contact.is_preferred;
        }
    });

    return {
        scope: {
            user: "=user",
            showConnection: "=?showConnection",
            isSuggestion: "=?isSuggestion",
            searchResult: "=searchResult",
            showConnectionIgnore: "=",
            showConnectionHide: "=",
            isCurrUser: "=",
            analyticsSource: "@",
            targetBlank: "=",
            isSmall: '=',
            contact: '=',
            isProfileConnection: '=',
            currentState: '=',
            onConnectionUpdate: '&?',
            showInitialsForMissingProfileImage: '='
        },
        templateUrl: 'angular/app/modules/network/features/directory/network_list_item_directive_template.html',
        controller: NetworkListItemDirectiveController,
        controllerAs: 'networkListItemVm',
        bindToController: true
    };
};
